const createSlug = title => title.replace(/\s/g, '-').replace(/[^a-zA-Z0-9-]/g, '').toLowerCase();

export default createSlug;
